import { render, staticRenderFns } from "./BotaoSig.vue?vue&type=template&id=309d46a0&lang=pug"
import script from "./BotaoSig.vue?vue&type=script&lang=js"
export * from "./BotaoSig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports